import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Dropdown, Modal, Input, Form, message as sysMessage, Flex } from 'antd';

import styles from './index.module.css';

import { appLogout, getLoginUserProfile } from '../../redux-root/actions';
import { Auth } from 'aws-amplify';

import logoImage from '../../assets/image/Dash-logo-RGB-1-1.png';


function TopPanel(props) {
    const [isVisiblePassword, setIsVisiblePassword] = useState(false)
    const [isVisibleUserProfile, setIsVisibleUserProfile] = useState(false)
    const [message, setMessage] = useState(undefined)
    const [oldPwd, setOldPwd] = useState(undefined)
    const [newPwd, setNewPwd] = useState(undefined)
    const [confirmPwd, setConfirmPwd] = useState(undefined)
    const [userProfile, setUserProfile] = useState(null)

    useEffect(() => {
            if (undefined !== props.userProfile) {
                setUserProfile(props.userProfile)
            }
        }, [props.userProfile]);

    const showModalPassword = () => {
        setIsVisiblePassword(true)
    }

    const showModalUserProfile=()=>{
        debugger
        props.getLoginUserProfile();
        setIsVisibleUserProfile(true)
    }

    const logoutClick = () => {
        props.appLogout();
    }

    const confirmHandlePassword = () => {
        if (!oldPwd || !newPwd) {
            setMessage("Please input password!")
        } else if (confirmPwd !== newPwd) {
            setMessage("Please confirm correct new password!")
        } else {
            Auth.currentAuthenticatedUser()
                .then(user => {
                    return Auth.changePassword(user, oldPwd, newPwd);
                })
                .then((data) => {
                    setMessage(data)
                    setIsVisiblePassword(false)
                    setOldPwd(undefined)
                    setNewPwd(undefined)
                    setConfirmPwd(undefined)
                })
                .catch((err) => {
                    setMessage("Please input correct password!")
                });
        }
    }

    const cancelHandlePassword = () => {
        setMessage(undefined)
        setIsVisiblePassword(false)
        setOldPwd(undefined)
        setNewPwd(undefined)
        setConfirmPwd(undefined)
    }

    const handleChange = (target, e) => {
        if (target === "oldPwd") {
            setOldPwd(e.target.value)
        } else if (target === "newPwd") {
            setNewPwd(e.target.value)
        } else if (target === "confirmPwd") {
            setConfirmPwd(e.target.value)
        }
    }


    const cancelHandleUserProfile = (target, e) => {
        setIsVisibleUserProfile(false)
    }

    
    const items = [
        {label: 'User Profile',key: '1',onClick:showModalUserProfile},
        {label: 'Change Password',key: '2',onClick:showModalPassword},
        {label: 'Logout',key: '3',onClick:logoutClick}
    ];
    return (
        <div className={styles['wrapper']}>
            <div className={styles['logo']}>
                <img src={logoImage} alt="logo" />
            </div>

            <div className={styles['profile']}>
                <Dropdown //overlay={menu}
                    menu={{items}}
                    >
                    <div className={styles['text']}>
                        Admin User
                    </div>
                </Dropdown>
            </div>

            <Modal title="Change Password"
                open={isVisiblePassword}
                onOk={confirmHandlePassword}
                onCancel={cancelHandlePassword}
                maskClosable={false}
                okText="Confirm"
                cancelText="Cancel">
                <Form.Item
                    name="old password"
                    label="Old Password"
                >
                    <Input.Password placeholder="Old Password" autoComplete="off" onChange={(e) => handleChange('oldPwd', e)} />
                </Form.Item>
                <Form.Item
                    name="new password"
                    label="New Password"
                >
                    <Input.Password placeholder="New Password" autoComplete="off" onChange={(e) => handleChange('newPwd', e)} />

                </Form.Item>
                <Form.Item
                    name="confirm password"
                    label="Confirm Password"
                >
                    <Input.Password placeholder="Confirm Password" autoComplete="off" onChange={(e) => handleChange('confirmPwd', e)} />

                </Form.Item>
                <p style={{ color: "red" }}>{message}</p>
            </Modal>

            <Modal title="User Profile"
                open={isVisibleUserProfile}
                footer={null}
                onCancel={cancelHandleUserProfile}>
                
                {userProfile?.fullName?<Flex horizontal gap={'middle'}><p>Full Name:</p> <p>{userProfile?.fullName}</p></Flex>:<Flex/>}
                {userProfile?.emailId?<Flex horizontal gap={'middle'}><p>Email ID:</p> <p>{userProfile?.emailId}</p></Flex>:<Flex/>}
                {userProfile?.mobileNumber?<Flex horizontal gap={'middle'}><p>Mobile Number:</p> <p>{userProfile?.mobileNumber}</p></Flex>:<Flex/>}
                {userProfile?.jobTitle?<Flex horizontal gap={'middle'}><p>Job Title:</p> <p>{userProfile?.jobTitle}</p></Flex>: <Flex/>}
                {userProfile?.userProfile?<Flex horizontal gap={'middle'}><p>Status:</p> <p>{userProfile?.status}</p></Flex>: <Flex/>}
                {userProfile?.createdOn?<Flex horizontal gap={'middle'}><p>Created On:</p> <p>{userProfile?.createdOn}</p></Flex>: <Flex/>}
                {userProfile?.updatedOn?<Flex horizontal gap={'middle'}><p>Updated On:</p> <p>{userProfile?.updatedOn}</p></Flex>: <Flex/>}
                
            </Modal>
        </div>
    );
}

const mapStateToProps = state => ({
    userProfile: state.app.userProfile
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            appLogout,
            getLoginUserProfile
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TopPanel);
